import { Group, TextInput, Tooltip } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { IconTrash } from '@tabler/icons-react';
import { isEvidenceFieldDeviceProperty } from 'components/forms/remote-source/config/device-properties';
import { EvidenceFieldSelect } from 'components/selects/EvidenceFieldSelect';
import DevicePropertySelect from 'components/selects/DevicePropertySelect';
import { ColumnPairing } from 'components/forms/remote-source/config/types';
import RevisionPlanPropertySelect from 'components/selects/RevisionPlanPropertySelect';
import DeviceFaultPropertySelect from 'components/selects/DeviceFaultPropertySelect';
import ActionIcon from 'components/ActionIcon';

interface ColumnPairingRowProps<TFormProp, TFormData> {
  formProp: TFormProp;
  form: UseFormReturnType<TFormData>;
  item: ColumnPairing;
  index: number;
  propType: 'device' | 'plan' | 'fault';
}

/**
 * A single row for Column Pairing configuration.
 */
export default function ColumnPairingRow<
  TFormProp extends string,
  TFormData extends Record<TFormProp, ColumnPairing[]>
>({ form, formProp, item, index, propType }: ColumnPairingRowProps<TFormProp, TFormData>) {
  const gridCols = propType === 'device' ? 'grid-cols-[80px_250px_350px_40px]' : 'grid-cols-[80px_250px_40px]';

  return (
    <Group className={`grid ${gridCols} items-center gap-y-0`}>
      <TextInput size="sm" {...form.getInputProps(`${formProp}.${index}.column`)} />
      {propType === 'device' && (
        <DevicePropertySelect size="sm" {...form.getInputProps(`${formProp}.${index}.property`)} />
      )}
      {propType === 'plan' && (
        <RevisionPlanPropertySelect size="sm" {...form.getInputProps(`${formProp}.${index}.property`)} />
      )}
      {propType === 'fault' && (
        <DeviceFaultPropertySelect size="sm" {...form.getInputProps(`${formProp}.${index}.property`)} />
      )}
      {isEvidenceFieldDeviceProperty(item.property) ? (
        <EvidenceFieldSelect
          applicability="devices"
          size="sm"
          {...form.getInputProps(`${formProp}.${index}.evidenceFieldId`)}
        />
      ) : propType === 'device' ? (
        <div />
      ) : null}
      <Tooltip label="Odstrániť stĺpec" openDelay={500} withArrow={false}>
        <ActionIcon variant="subtle" size="sm" onClick={() => form.removeListItem(formProp, index)}>
          <IconTrash />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
}
